import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Stack,
  IconButton,
  Chip,
  Divider,
} from '@mui/material';
import ApiClient from '../../../config/api';
import { setIsLoading } from '../../../store/globalSlice';
import { useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Call, Box1, CallOutgoing, Location } from 'iconsax-react';

const MissionCard = ({
  setMissionNo,
  item,
  index,
  setOpenDetail,
  setSelectedData,
  setSelectedTask,
  setSelectedTaskDetail,
}) => {
  const api = ApiClient();
  const dispatch = useDispatch();
  const theme = useTheme();
  const mutedIcon = theme.palette.text.secondary;

  const handleSelect = async () => {
    try {
      dispatch(setIsLoading(true));
      const orderRequests = item?.parcels?.map((item) =>
        api.get(`/api/app/v1/agent/parcels/${item?.parcelNo}`)
      );
      const orderResponses = await Promise.all(orderRequests);
      const ordersData = orderResponses.map((response) => response?.data);
      setSelectedData(ordersData);
      setSelectedTask(item);
      setSelectedTaskDetail(item?.parcels);
      setMissionNo(index + 1);
      setOpenDetail(true);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: 'background.card',
          p: '12px',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '16px',
          width: '100%',
          cursor: 'pointer',
          transition: 'opacity 0.3s ease',
          margin: '10px 0px',
          '&:hover': {
            opacity: 0.7,
          },
        }}
        onClick={() => handleSelect()}
      >
        <Grid container>
          <Grid
            item
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            xs={12}
            display={'flex'}
            flexWrap={'wrap'}
          >
            <Stack flexDirection={'row'} alignItems={'center'}>
              <Box
                component="span"
                sx={{
                  bgcolor: 'primary.main',
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  color: 'primary.contrastText',
                }}
              >
                {index + 1}
              </Box>
              <Typography
                variant={'caption'}
                textAlign={'left'}
                mt={'2px'}
                ml={1}
              >
                {item?.fullName}
              </Typography>
            </Stack>
            <Chip
              size="small"
              variant="filled"
              label={item?.serviceType}
            />
          </Grid>
          <Divider
            sx={{
              width: '100%',
              marginTop: '10px',
            }}
          />
          <Grid
            item
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            xs={12}
            display={'flex'}
            flexWrap={'wrap'}
            marginTop="10px"
          >
            <Stack
              sx={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box1 size="22" color={mutedIcon} />

              <Typography
                variant={'caption'}
                textAlign={'left'}
                mt={'2px'}
                ml={1}
              >
                {item?.count} مرسوله
              </Typography>
            </Stack>
          </Grid>
          <Grid
            item
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            xs={12}
            display={'flex'}
            flexWrap={'wrap'}
            marginTop="10px"
          >
            <Stack
              sx={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Call size="22" color={mutedIcon} />
              <Typography
                variant={'caption'}
                textAlign={'left'}
                mt={'2px'}
                ml={1}
              >
                {item?.phoneNumber}
              </Typography>
            </Stack>
            <IconButton
              sx={{ bgcolor: 'background.muted', borderRadius: '8px' }}
              aria-label="delete"
              size="small"
              href={`tel:${item?.phoneNumber}`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <CallOutgoing variant="Bold" color={theme.palette.text.primary} />
            </IconButton>
          </Grid>
          <Grid
            item
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            xs={12}
            display={'flex'}
            flexWrap={'wrap'}
            marginTop="10px"
          >
            <Stack
              sx={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Location size="22" color={mutedIcon} />
              <Typography
                variant={'caption'}
                textAlign={'left'}
                mt={'2px'}
                ml={1}
              >
                {item?.address}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MissionCard;
